import React from 'react';
import MultiAutoCompleteFilter from 'components/list/Filters/types/MultiAutoCompleteFilter';
import rolesHelper from 'helpers/roles';

const MultiProviderIdFilter = <MultiAutoCompleteFilter
    label='filters.components.providerId.label'
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        role_id: [
            rolesHelper.getProviderRoleId(),
        ],
        size: '12',
        sort_by: 'name',
        sort_direction: 'asc',
    } }
    reference='accounts'
    optionValue='id'
    searchBy='name'
    source='provider_id'
/>;

export default MultiProviderIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/MultiProviderIdFilter.js